{
  "reports": {
    "incentiveReport": "Incentive Report",
    "incentiveReportDescription": "Finalized incentive amounts per equipment and reporting period, with credit and REC pricing.",
    "equipmentReport": "Equipment Report",
    "equipmentReportDescription": "Each piece of equipment for every reporting period it was active in, with usage data where reported.",
    "facilityReport": "Facility Report",
    "facilityReportDescription": "Facility details with program, utility, and contact information.",
    "userReport": "User Report",
    "userReportDescription": "User accounts per client with role, status, and last login.",
    "includedColumns": "Included Columns",
    "columnCountLabel": "Column Count:",
    "filterClientName": "Client Name",
    "filterReportingPeriod": "Reporting Period",
    "filterStatus": "Status",
    "filterProgram": "Program",
    "filterFacilityAddress": "Facility Address",
    "filterCity": "City",
    "filterStateProvince": "State / Province",
    "filterEquipmentCategory": "Equipment Category",
    "filterEquipmentType": "Equipment Type",
    "filterManufacturer": "Manufacturer",
    "filterMetered": "Metered",
    "filterFseUtility": "FSE Utility",
    "filterContactName": "Contact Name",
    "filterUserRole": "User Role",
    "optionAll": "All",
    "optionActive": "Active",
    "optionInactive": "Inactive",
    "optionYes": "Yes",
    "optionNo": "No",
    "generateReport": "GENERATE REPORT",
    "generatingReport": "GENERATING...",
    "generatingHint": "Large reports can take a few minutes. Keep this page open until the download starts.",
    "noFilterHint": "Leave a filter empty to include everything."
  }
}
